module.exports = __webpack_public_path__ + "static/media/webIcon.4220e839.svg";